import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, fonts, spacing } from '../../../constants';
import {
  logoBoxStyles,
  logoImageStyles,
  headerStyles,
  headerTitleStyles,
  headerDescriptionStyles,
} from '../../../constants/manualLogin';
import logoImage from '../../../assets/Airports_Authority_of_India_logo.svg.png';

/**
 * LoginHeader Component
 * Header section with logo, title, and description
 */
const LoginHeader = () => {
  return (
    <>
      <Box sx={logoBoxStyles}>
        <Box component="img" src={logoImage} alt="Airports Authority of India logo" sx={logoImageStyles} />
      </Box>
      <Box sx={headerStyles}>
        <Typography variant="h4" component="h1" sx={headerTitleStyles}>
          Welcome Back
        </Typography>
        <Typography variant="body2" sx={headerDescriptionStyles}>
          Log in to manage your queries, track operations, and gain real-time insights.
        </Typography>
      </Box>
    </>
  );
};

export default LoginHeader;
